import React from 'react';

/**
 * Shared brand trust band — same design language across the entire SEO surface.
 * Renders right below the hero on every SEO landing page so the homepage
 * brand promise (200K customers, 4.8★, 32+ cities, 30-day warranty) is
 * consistently conveyed end-to-end. Booking-driven SEO plan 2026-04-28.
 */
const ITEMS = [
  { value: '2,00,000+', label: 'Customers Served' },
  { value: '4.8\u2605', label: 'Customer Rating' },
  { value: '32+', label: 'Cities in India' },
  { value: '30-Day', label: 'Service Warranty' },
];

const BrandTrustBand = ({ items = ITEMS, variant = 'default' }) => (
  <div className={`rr-trust-bar${variant === 'compact' ? ' rr-trust-bar--compact' : ''}`}>
    <div className="rr-container">
      <div className="rr-trust-bar__inner">
        {items.map((it, i) => (
          <div key={i} className="rr-trust-bar__item">
            <strong>{it.value}</strong> {it.label}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default BrandTrustBand;
